import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const MinusIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M19 13H5v-2h14v2Z" />
  </Icon>
);

export default memo(MinusIcon);
